<div class="page-container">
  <div class="page-header"><h3 i18n>Booking assignments</h3></div>
  <div class="page-content">
    <form [formGroup]="filterForm">
      <div class="filter-selectors">
        <div class="main-filter-selectors">
          @if (maintenanceShops.length > 1) {
            <mc-typeahead
              label="Shop"
              fit="small"
              placeholder="Type to search..."
              highlight="true"
              showlistonfocus="true"
              [data]="shopTypeaheadData"
              [value]="initialShopData?.label ?? ''"
              maxoptions="200"
              optionsheight="400px"
              (optionselected)="onShopSelected($event)">
            </mc-typeahead>
          }

          <div>
            <mc-label fit="small" i18n>Booking Number</mc-label>
            <mc-input-group hiddenlegend fit="small">
              <mc-input
                hiddenlabel
                placeholder="Search..."
                fit="small"
                ngDefaultControl
                formControlName="bookingNumber"
                [clearbutton]="true"
                (keydown.enter)="onSearch()"
                (clearbuttonclick)="onClearSearch()"></mc-input>
              <mc-button
                appearance="primary"
                variant="filled"
                fit="small"
                hiddenlabel
                label="search"
                icon="magnifying-glass"
                (click)="onSearch()"
                (keydown.enter)="onSearch()"></mc-button>
            </mc-input-group>
          </div>
        </div>
      </div>
    </form>

    <div class="data-table-wrapper">
      @if (searchMode) {
        <div class="data-table-header">
          <div class="applied-filters">
            <mc-tag withaction fit="small" appearance="info" (dismiss)="onClearSearch()"
              >Booking Number: {{ searchedBookingNumber }}</mc-tag
            >
            @for (tag of filterTags; track tag.key) {
              <mc-tag withaction (dismiss)="clearFilter(tag.key)" fit="small" appearance="info">{{ tag.value }}</mc-tag>
            }
            <mc-button
              label="Clear Filters"
              appearance="secondary"
              variant="plain"
              fit="small"
              (click)="clearAllFilters()"
              (keydown.enter)="clearAllFilters()"
              (keydown.space)="clearAllFilters()"></mc-button>
          </div>
        </div>
        @if (searchLoading) {
          <div class="skeleton-wrapper">
            <ngx-skeleton-loader count="3" appearance="line" [theme]="{ height: '28px', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
          </div>
        } @else if (searchResults.length > 0) {
          <div class="data-table-content">
            <mc-table
              [data]="searchResults"
              [columns]="columns"
              nowrap="true"
              fit="small"
              headersticky
              (rowclick)="onRowClick($event)"></mc-table>
          </div>
        } @else {
          <div class="data-table-content">
            <ng-container *ngTemplateOutlet="noData"></ng-container>
          </div>
        }
      } @else {
        @if (tableData$ | async; as data) {
          @if (filterTags.length > 0) {
            <div class="data-table-header">
              <div class="applied-filters">
                @for (tag of filterTags; track tag.key) {
                  <mc-tag withaction (dismiss)="clearFilter(tag.key)" fit="small" appearance="info">{{ tag.value }}</mc-tag>
                }
                <mc-button
                  label="Clear Filters"
                  appearance="secondary"
                  variant="plain"
                  (click)="clearAllFilters()"
                  (keydown.enter)="clearAllFilters()"
                  (keydown.space)="clearAllFilters()"
                  fit="small"></mc-button>
              </div>
            </div>
          }
          <div class="data-table-content">
            @if (loading || data.length > 0) {
              <mc-table
                sortmanual
                [sortdefaultdirection]="currentSortDirection"
                [sortdefaultcolumnid]="currentSortColumn"
                [data]="loading ? mockDataForLoadingAnimation : data"
                [columns]="columns"
                nowrap="true"
                fit="small"
                [height]="'100%'"
                (sortchange)="onSortChange($event)"
                (rowclick)="onRowClick($event)"
                headersticky>
                @for (row of mockDataForLoadingAnimation; track $index) {
                  @for (col of columns; track $index) {
                    <div slot="{{ row.id }}_{{ col.id }}">
                      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '16px', margin: '0' }"></ngx-skeleton-loader>
                    </div>
                  }
                }
              </mc-table>
            } @else {
              <ng-container *ngTemplateOutlet="noData"></ng-container>
            }
          </div>

          <div class="data-table-pagination">
            @if (pagination$ | async; as pagination) {
              @if (data.length > 0 || totalFilteredCount > 0) {
                <mc-pagination
                  variant="select"
                  [totalrecords]="totalFilteredCount"
                  fit="small"
                  showpagesize
                  showpagestatus
                  [currentpage]="pagination.currentPage"
                  [pagesize]="pagination.pageLimit"
                  (pagesizechange)="onPageLimitChange($event)"
                  (pagechange)="onPageChange($event)">
                </mc-pagination>
              }
            }
          </div>
        }
      }
    </div>
  </div>
</div>

<ng-template #noData>
  <div class="no-data-found-container">
    <div class="message">
      <span i18n>No Data Found</span>
    </div>
    <div class="sub-message">
      <span i18n>To widen your search, change or remove filters.</span>
    </div>
    <div class="action">
      <mc-button
        i18n-label="Button"
        label="Clear all filters"
        variant="filled"
        appearance="primary"
        (click)="clearAllFilters()"
        (keydown.enter)="clearAllFilters()"
        (keydown.space)="clearAllFilters()"
        fit="small"></mc-button>
    </div>
  </div>
</ng-template>
